export default __webpack_public_path__ + "static/media/iphone.0b14b226.png";